import { RemoveCircle, Tag } from "@mui/icons-material";
import React, { memo } from "react";
import { NodeCard, mutedText, valuePill } from "./commonNode";

const accent = "#dc3545";

export default memo(({ data, isConnectable, id }) => (
  <NodeCard
    id={id}
    title="Remover Tag"
    accent={accent}
    icon={<RemoveCircle sx={{ width: 15, height: 15, color: accent }} />}
    isConnectable={isConnectable}
    targetTop="50%"
    sourceHandles={[{ id: "a", top: "72%" }]}
  >
    <div style={{ ...valuePill(accent), display: "flex", alignItems: "center", gap: 6 }}>
      <Tag sx={{ width: 14, height: 14, color: accent, flexShrink: 0 }} />
      {data?.tag?.name || "Tag não selecionada"}
    </div>
    {data?.tag?.name && (
      <div style={{ ...mutedText, marginTop: 7 }}>
        Remove a tag do contato
      </div>
    )}
  </NodeCard>
));
